export default __webpack_public_path__ + "static/media/Nobal_Tanya_Headshot.0d91f0ec.jpg";